module.exports = __webpack_public_path__ + "img/2_1_class_extension.866af511.jpg";